import React, { useState } from "react";
import "../PagesContent/Consulting.css";
import { ConsultingServices } from "../Exports/dataConsulting";

const Consulting = () => {
  console.log(ConsultingServices);

  const [currentPage, setCurrentPage] = useState(0);

  const displayData = ConsultingServices[currentPage];

  const goToNextPage = () => {
    if (currentPage < ConsultingServices.length - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div className="consultingConteneur">
      <div className="consultingHeader">
        <p>

        </p>
      </div>
      <div className="consultingBlockService">
        <div key={currentPage} className="consultingServiceContenu">
          <div>
            <img
              src={displayData.image}
              style={{ width: "100%", height: "100%", borderRadius: "20px" }}
              alt="imageDescriptif"
            />
          </div>
          <div>
            <h2 className="heading">{displayData.title}</h2>
            <h1 style={{ color: "black" }}>Description</h1>
            <p style={{ fontSize: "18px" }}>{displayData.description}</p>
            <h2 style={{ color: "black" }}>Livrables Attendus</h2>
            <p style={{ fontSize: "18px" }}>{displayData.LivrablesAttendus}</p>
            <h2 style={{ color: "black" }}>Duree Contrat</h2>
            <p style={{ fontSize: "18px" }}>{displayData.DuréeContrat}</p>
            {/*
            <h2 style={{ color: "black" }}>coût</h2>
            <p style={{ fontSize: "18px" }}>{displayData.coût}</p>
            */}

            <h2 style={{ color: "black" }}>Ressources Allouées</h2>
            <p style={{ fontSize: "18px" }}>{displayData.RessourcesAllouées}</p>
            <br></br>
            <a className="btn" href="/contact">Contactez-nous</a>
          </div>

        </div>




        <div className="pagination">
          <div>
            {currentPage > 0 && (
              <button
                onClick={goToPreviousPage}
                style={{
                  border: "1px solid transparent",
                  fontWeight: "500",
                  padding: "5px 10px",
                  borderRadius: "15px",
                  backgroundColor: "antiquewhite",
                }}
              >
                précédent
              </button>
            )}
          </div>

          <div>
            {currentPage < ConsultingServices.length - 1 && (
              <button
                onClick={goToNextPage}
                style={{
                  border: "1px solid transparent",
                  fontWeight: "500",
                  padding: "5px 10px",
                  borderRadius: "15px",
                  backgroundColor: "antiquewhite",
                }}
              >
                suivant
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Consulting;
